import { render, staticRenderFns } from "./singer.vue?vue&type=template&id=49a3ea1d&"
import script from "./singer.vue?vue&type=script&lang=js&"
export * from "./singer.vue?vue&type=script&lang=js&"
import style0 from "./singer.vue?vue&type=style&index=0&id=49a3ea1d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports